import { Integration_Names_Enum } from '@main/graphql/types.generated';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';
import { AtlassianAuthPat, AtlassianAuthSaOauth } from '../../lib/atlassian';

export type JiraConnectorConfig = typeof JiraConnector._.Config;

export const JiraConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Jira,
  logoPath: 'images/jira-logo.svg',
  categories: [IntegrationConnectorCategory.DevOps],
  auths: IntegrationAuth.group([AtlassianAuthSaOauth, { ...AtlassianAuthPat, deprecated: true }]),
});
